import React, { useState, useRef ,useEffect} from "react";

export default function ReferralDropdown({
  dropDownList,
  selectedValue,
  setSelectedValue,
}: any) {
  const [isOpen, setIsOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const recruiterCode = "REC";
  const dropdownRef = useRef(null);
  

   useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
        setExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
     
       }, []);

  const handleMainSelect = (item: any) => {
    
    if (item.code === recruiterCode) {
      setExpanded((prev:any) => !prev);
      return;
    }

    
    setSelectedValue({
      label: item.label,
      value: item.code,
    });

    setExpanded(false);
    setIsOpen(false);
  };

  const handleRecruiterSelect = (rec: any) => {
    
    setSelectedValue({
      label: rec.label,
      value: rec.code,
    });

    setExpanded(false);
    setIsOpen(false);
  };

  return (
    <div ref={dropdownRef} className="relative w-full ">
      {/* Display Value */}
      <div
        className={`border-b-2 border-gray-300 px-1 ${selectedValue?" font-semibold ":""}  text-sm  py-2 cursor-pointer`}
        style={{ color: "#15415E" }}
        onClick={() => setIsOpen((p: any) => !p)}
      >
       
       {selectedValue?.label || "Select Source"}
       
       
      </div>

      <label className="absolute -top-4 text-lg text-[#15415E] bg-white px-1">
        Source
      </label>

      {/* Dropdown List */}
      {isOpen && (
        <div className="absolute w-full border bg-gray-100 z-10 max-height-60 overflow-auto">
          {dropDownList.map((item: any) => (
            <div key={item.id}>
              {/* Main Item */}
              <div
                className={`px-3 py-2 hover:bg-gray-100 cursor-pointer
                ${item.code === recruiterCode ? "font" : ""}`}
                onClick={() => handleMainSelect(item)}
              >
                {item.label}
              </div>

  
              {item.code === recruiterCode && expanded && item.recruiters && (
                <div className="ml-5 border-l">
                  {item.recruiters.map((rec: any) => (
                    <div
                      key={rec.id}
                      className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => handleRecruiterSelect(rec)}
                    >
                      {rec.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
